module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAqElEQVRIS+3SsQkCMRiG4edaaxdxAEELG1sbcRULrVzFzlpsdAbHcAFLJeAJHnjJBblCki4k//fme0mlp1X1xFFA2aaLuv9RN4lUucSqpnyGADlHgqZohaWABjhi/AUWAHPc2x6TAgrzI5wwbITdMMP1F+rqjCX2jcAFDjFIOE9tVGdtsXlt1tilQHJAYSa0emCVCskFdcl/3+2qLgtSGmVrK+qKug8DT3/vDxt4670BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow.png
// module id = OsgU
// module chunks = 1